import { BlogPost, Author, Category } from '../types';

// Yazarlar
export const authors: Author[] = [
  {
    id: '1',
    name: 'YolSepetiGO',
    avatar: '/goyazililogo.webp',
    role: 'YolSepetiGO Ekibi',
    bio: 'YolSepetiGO - Türkiye\'nin güvenilir yol yardım platformu.',
  },
  {
    id: '2',
    name: 'YolSepetiGO',
    avatar: '/goyazililogo.webp',
    role: 'YolSepetiGO Ekibi',
    bio: 'YolSepetiGO - Türkiye\'nin güvenilir yol yardım platformu.',
  },
  {
    id: '3',
    name: 'YolSepetiGO',
    avatar: '/goyazililogo.webp',
    role: 'YolSepetiGO Ekibi',
    bio: 'YolSepetiGO - Türkiye\'nin güvenilir yol yardım platformu.',
  },
];

// Kategoriler
export const categories: Category[] = [
  { id: '1', name: 'Çekici Hizmetleri', slug: 'cekici-hizmetleri', color: '#14b8aa' },
  { id: '2', name: 'Yol Yardım', slug: 'yol-yardim', color: '#ef4444' },
  { id: '3', name: 'Nakliye', slug: 'nakliye', color: '#22c55e' },
  { id: '4', name: 'Vinç Hizmetleri', slug: 'vinc-hizmetleri', color: '#f97316' },
  { id: '5', name: 'İpuçları', slug: 'ipuclari', color: '#8b5cf6' },
  { id: '6', name: 'Haberler', slug: 'haberler', color: '#06b6d4' },
  { id: '7', name: 'Servis', slug: 'servis', color: '#2c4a63' },
  { id: '8', name: 'VIP Taşıma', slug: 'vip-tasima', color: '#b8860b' },
];

// Blog yazıları
export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'yolda-kalmamak-icin-10-oneri',
    title: 'Yolda Kalmamak İçin 10 Altın Öneri',
    excerpt: 'Uzun yolculuklarda araç arızası yaşamamak için dikkat etmeniz gereken 10 kritik nokta. Aracınızı yola çıkmadan önce kontrol edin.',
    content: `
# Yolda Kalmamak İçin 10 Altın Öneri

Uzun yolculuklara çıkmadan önce aracınızı kontrol etmek, yolda kalmaktan korunmanın en etkili yoludur. İşte dikkat etmeniz gereken 10 kritik nokta:

## 1. Lastik Basıncını Kontrol Edin

Lastik basıncı, hem güvenliğiniz hem de yakıt tasarrufu açısından kritik öneme sahiptir. Yola çıkmadan önce mutlaka kontrol edin.

## 2. Yağ Seviyesini Kontrol Edin

Motor yağı, aracınızın kalbi olan motorun sağlıklı çalışması için şarttır. Yağ seviyesinin minimum ile maksimum arasında olduğundan emin olun.

## 3. Akü Durumunu Kontrol Edin

Özellikle kış aylarında akü arızaları sık yaşanır. Akünüzün en az 2 yılda bir kontrol edilmesi önerilir.

## 4. Fren Sistemini Kontrol Edin

Frenler hayat kurtarır. Fren balatalarının durumunu ve fren hidroliği seviyesini kontrol ettirin.

## 5. Soğutma Sistemini Kontrol Edin

Antifriz seviyesi ve radyatör durumu, motorunuzun aşırı ısınmasını önler.

## 6. Silecek ve Silecek Suyunu Kontrol Edin

Görüş mesafesi güvenliğiniz için kritiktir. Sileceklerinizin iyi çalıştığından emin olun.

## 7. Farları Kontrol Edin

Tüm farlarınızın çalıştığından emin olun: ön farlar, arka farlar, stop lambaları, sinyal lambaları.

## 8. Stepne ve Kriko Kontrolü

Stepnenizin basıncının uygun olduğundan ve krikonuzun çalıştığından emin olun.

## 9. Acil Durum Kiti

Aracınızda yangın söndürücü, reflektör, ilk yardım çantası bulundurun.

## 10. Yakıt Durumu

Yola çıkmadan önce yakıt deposunu doldurun ve rotanızdaki benzin istasyonlarını not edin.

---

**YolSepetiGO** olarak 7/24 yanınızdayız. Herhangi bir sorun yaşadığınızda bizi arayabilirsiniz.
    `,
    author: authors[2],
    category: categories[4],
    tags: ['araç bakım', 'yolculuk', 'güvenlik', 'ipuçları'],
    coverImage: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&h=400&fit=crop',
    publishedAt: '2024-12-20',
    readTime: 8,
    featured: true,
  },
  {
    id: '2',
    slug: 'cekici-hizmeti-nasil-calisir',
    title: 'Çekici Hizmeti Nasıl Çalışır? Adım Adım Rehber',
    excerpt: 'Çekici hizmeti almak istediğinizde bilmeniz gereken her şey. Süreç nasıl işliyor, fiyatlar nasıl belirleniyor?',
    content: `
# Çekici Hizmeti Nasıl Çalışır?

Aracınız yolda kaldığında çekici hizmeti almak stresli bir deneyim olabilir. Bu rehberde sürecin nasıl işlediğini anlatıyoruz.

## Çekici Çağırma Süreci

1. **Konum Belirleme**: Güvenli bir yere çekilin ve konumunuzu belirleyin.
2. **Hizmet Talebi**: YolSepetiGO uygulamasından veya telefonla hizmet talep edin.
3. **Fiyat Onayı**: Size en uygun fiyat teklifi sunulur.
4. **Çekici Geliş**: En yakın çekici aracınızın konumuna yönlendirilir.
5. **Aracın Yüklenmesi**: Profesyonel ekip aracınızı güvenle yükler.
6. **Teslimat**: Aracınız belirlenen adrese teslim edilir.

## Fiyatlandırma Nasıl Yapılır?

- **Mesafe**: Temel fiyatlandırma faktörü
- **Araç Tipi**: Binek, SUV, kamyonet gibi kategoriler
- **Saat**: Gece ve hafta sonu farklılıkları olabilir
- **Ek Hizmetler**: Akü takviye, lastik değişimi gibi

## Dikkat Edilmesi Gerekenler

- Aracınızın anahtarını ve ruhsatını hazır bulundurun
- Değerli eşyalarınızı araçtan alın
- Hasar tespiti için fotoğraf çekin

---

**YolSepetiGO** ile çekici hizmeti almak artık çok kolay!
    `,
    author: authors[0],
    category: categories[0],
    tags: ['çekici', 'araç kurtarma', 'rehber'],
    coverImage: 'https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=800&h=400&fit=crop',
    publishedAt: '2024-12-18',
    readTime: 6,
    featured: true,
  },
  {
    id: '3',
    slug: 'kis-aylarinda-arac-bakimi',
    title: 'Kış Aylarında Araç Bakımı: Nelere Dikkat Etmeli?',
    excerpt: 'Soğuk kış aylarında aracınızı korumak ve güvenli sürüş için yapmanız gerekenler.',
    content: `
# Kış Aylarında Araç Bakımı

Kış ayları, araçlar için zorlu bir dönemdir. İşte aracınızı kışa hazırlamanız için yapmanız gerekenler.

## Lastik Seçimi

Kış lastikleri, +7°C altındaki sıcaklıklarda yaz lastiklerinden çok daha iyi tutunma sağlar.

## Antifriz Kontrolü

Antifriz seviyesi ve yoğunluğu kontrol edilmeli. -40°C'ye kadar koruma sağladığından emin olun.

## Akü Bakımı

Soğuk havalarda akü kapasitesi düşer. Akünüzün sağlığını kontrol ettirin.

## Yağ Değişimi

Kış için uygun viskozitede motor yağı kullanın.

---

Kışın yolda kalmamak için önleminizi alın, **YolSepetiGO** her zaman yanınızda!
    `,
    author: authors[2],
    category: categories[4],
    tags: ['kış bakımı', 'lastik', 'antifriz', 'akü'],
    coverImage: 'https://images.unsplash.com/photo-1516733968668-dbdce39c4651?w=800&h=400&fit=crop',
    publishedAt: '2024-12-15',
    readTime: 5,
  },
  {
    id: '4',
    slug: 'ev-tasima-rehberi',
    title: 'Ev Taşıma Rehberi: Stressiz Taşınma İçin İpuçları',
    excerpt: 'Ev taşımak zorlu bir süreç olabilir. Bu rehberle taşınma sürecinizi kolaylaştırın.',
    content: `
# Ev Taşıma Rehberi

Ev taşımak hayatın en stresli deneyimlerinden biri olabilir. Ancak doğru planlama ile bu süreci kolaylaştırabilirsiniz.

## Taşınmadan Önce

1. **Liste Yapın**: Tüm eşyalarınızın listesini çıkarın
2. **Gereksiz Eşyaları Ayıklayın**: Kullanmadığınız eşyaları bağışlayın veya satın
3. **Kutu Temini**: Yeterli sayıda kutu ve ambalaj malzemesi edinin
4. **Etiketleme**: Her kutuyu içeriğine göre etiketleyin

## Taşınma Günü

- Değerli eşyaları ayrı tutun
- Acil ihtiyaç kutusunu ayırın
- Taşıyıcılara net talimatlar verin

## Yeni Evinizde

1. Önce mutfak ve banyoyu düzenleyin
2. Yatak odalarını hazırlayın
3. Diğer odaları yavaş yavaş yerleştirin

---

**YolSepetiGO Nakliye** ile taşınmak artık çok kolay!
    `,
    author: authors[1],
    category: categories[2],
    tags: ['nakliye', 'ev taşıma', 'taşınma ipuçları'],
    coverImage: 'https://images.unsplash.com/photo-1612630741022-b29ec17d013d?w=800&h=400&fit=crop',
    publishedAt: '2024-12-12',
    readTime: 7,
  },
  {
    id: '5',
    slug: 'vinc-hizmeti-ne-zaman-gerekli',
    title: 'Vinç Hizmeti Ne Zaman Gerekli? Hangi Durumlarda Çekici Yetmez?',
    excerpt: 'Ağır araçlar, kazalar ve özel durumlar için vinç hizmeti ne zaman gereklidir?',
    content: `
# Vinç Hizmeti Ne Zaman Gerekli?

Bazen standart çekici hizmeti yeterli olmayabilir. İşte vinç hizmeti gerektiren durumlar:

## Vinç Gerektiren Durumlar

1. **Ağır Araçlar**: Kamyon, TIR, otobüs gibi ağır araçlar
2. **Derin Çukurlar**: Araç ulaşılması zor bir yere düştüyse
3. **Devrilmiş Araçlar**: Yan yatmış veya ters dönmüş araçlar
4. **İnşaat Projeleri**: Ağır malzeme taşıma
5. **Konteyner Taşıma**: Liman ve depo operasyonları

## Vinç Türleri

- **Mobil Vinç**: Hareket kabiliyeti yüksek
- **Sabit Vinç**: Ağır yükler için
- **Kurtarma Vinci**: Özel araç kurtarma operasyonları

---

**YolSepetiGO Vinç Hizmetleri** ile her durumda yanınızdayız!
    `,
    author: authors[0],
    category: categories[3],
    tags: ['vinç', 'ağır araç', 'kurtarma'],
    coverImage: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=400&fit=crop',
    publishedAt: '2024-12-10',
    readTime: 4,
  },
  {
    id: '6',
    slug: 'yolsepetigo-yeni-ozellikler-2024',
    title: 'YolSepetiGO 2024 Yeni Özellikleri: Daha Hızlı, Daha Kolay',
    excerpt: 'YolSepetiGO uygulamasına eklenen yeni özellikler ve güncellemeler hakkında her şey.',
    content: `
# YolSepetiGO 2024 Yeni Özellikleri

2024 yılında YolSepetiGO olarak birçok yeni özellik ekledik.

## Yeni Özellikler

### Anlık Konum Takibi
Çekici veya yardım ekibinin size ne kadar uzakta olduğunu gerçek zamanlı takip edin.

### Hızlı Fiyat Hesaplama
Rota ve araç bilgilerinize göre anında fiyat öğrenin.

### 7/24 Canlı Destek
Her an yanınızda olan müşteri destek ekibimiz.

### Çoklu Ödeme Seçenekleri
Kredi kartı, banka kartı ve kapıda ödeme seçenekleri.

## Gelecek Güncellemeler

- Üyelik programı
- Kurumsal filo yönetimi
- Çoklu dil desteği

---

**YolSepetiGO** - Yolda kaldığınızda tek adresiniz!
    `,
    author: authors[1],
    category: categories[5],
    tags: ['güncelleme', 'yeni özellikler', 'uygulama'],
    coverImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop',
    publishedAt: '2024-12-05',
    readTime: 4,
    featured: true,
  },
  {
    id: '7',
    slug: 'personel-servis-tasimaciligi-rehberi',
    title: 'Personel Servis Taşımacılığında Nelere Dikkat Edilmeli?',
    excerpt: 'Çalışanlarınızın işe konforlu, güvenli ve zamanında ulaşması için doğru servis taşımacılığı çözümünü seçmenin püf noktaları.',
    content: `
# Personel Servis Taşımacılığında Nelere Dikkat Edilmeli?

Düzenli personel servisi, çalışan memnuniyetini artıran ve verimliliği doğrudan etkileyen önemli bir hizmettir. Doğru kurgulanmış bir servis sistemi, çalışanların işe zamanında ve dinç ulaşmasını sağlar.

## Personel Servisinin Faydaları

1. **Zamanında Ulaşım**: Çalışanlar işe vaktinde ve stressiz varır.
2. **Konfor**: Konforlu araçlarla yorgunluk minimuma iner.
3. **Maliyet Avantajı**: Toplu taşımacılık bireysel ulaşımdan daha ekonomiktir.
4. **Çalışan Memnuniyeti**: Düzenli servis, kurumsal bağlılığı güçlendirir.

## Doğru Servis İçin Nelere Dikkat Edilmeli?

- **Güzergah Planlaması**: Duraklar, çalışanların yoğunlaştığı bölgelere göre optimize edilmeli.
- **Araç Durumu**: Bakımlı, temiz ve konforlu araçlar tercih edilmeli.
- **Deneyimli Şoförler**: Güvenli sürüş için profesyonel şoförler şart.
- **Esneklik**: Vardiya saatlerine uygun, esnek sefer planlaması önemli.

## YolSepetiGO Servis ile Kolay Yönetim

YolSepetiGO **servis taşımacılığı** ile personel ulaşımınızı tek platformdan planlayın:

- Güzergah ve durakları kolayca belirleyin
- Düzenli veya tek seferlik seferler oluşturun
- Şeffaf fiyatlandırma ile bütçenizi önceden bilin
- Seferleri canlı olarak takip edin

---

**YolSepetiGO Servis** ile personel taşımacılığınız düzenli ve güvenilir!
    `,
    author: authors[0],
    category: categories[6],
    tags: ['servis taşımacılığı', 'personel servisi', 'kurumsal ulaşım', 'toplu taşıma'],
    coverImage: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800&h=400&fit=crop',
    publishedAt: '2024-12-28',
    readTime: 5,
    featured: true,
  },
  {
    id: '8',
    slug: 'organizasyon-grup-tasimaciligi-rehberi',
    title: 'Organizasyon ve Grup Taşımacılığı: Etkinliğiniz İçin Doğru Çözüm',
    excerpt: 'Düğün, konser, tur veya kurumsal etkinlik... Kalabalık gruplarınızı tek noktadan, düzenli ve konforlu şekilde taşımanın yolları.',
    content: `
# Organizasyon ve Grup Taşımacılığı

Kalabalık grupların ulaşımı, iyi planlanmadığında etkinliğin en stresli kısmına dönüşebilir. Doğru organizasyon taşımacılığı ile herkes aynı anda, konforlu ve sorunsuz şekilde yola çıkar.

## Hangi Etkinlikler İçin Uygundur?

- **Düğün ve nişan**: Davetlilerin toplu taşınması
- **Konser ve festival**: Grup transferi
- **Kurumsal etkinlikler**: Toplantı, seminer ve lansman katılımcıları
- **Turlar ve geziler**: Gezi grupları için düzenli ulaşım
- **Spor müsabakaları**: Takım ve taraftar taşımacılığı

## Başarılı Bir Grup Taşımacılığı İçin

1. **Katılımcı Sayısını Netleştirin**: Doğru araç kapasitesi için önemli.
2. **Güzergah ve Durakları Planlayın**: Toplanma noktalarını önceden belirleyin.
3. **Zamanlamayı Ayarlayın**: Etkinlik başlangıcına göre kalkış saatini planlayın.
4. **Tek Noktadan Yönetin**: Tüm seferleri tek talepte koordine edin.

## YolSepetiGO ile Organizasyon Taşımacılığı

YolSepetiGO **servis taşımacılığı** ile etkinlik ulaşımınızı kolayca planlayın:

- İhtiyacınıza uygun araç ve kapasite
- Esnek güzergah ve sefer planlaması
- Şeffaf fiyatlandırma ile bütçe kontrolü
- Seferleri canlı takip imkanı

---

**YolSepetiGO Servis** ile organizasyonunuzun ulaşımı güvende!
    `,
    author: authors[2],
    category: categories[6],
    tags: ['servis taşımacılığı', 'organizasyon taşıma', 'grup taşıma', 'etkinlik ulaşımı'],
    coverImage: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=400&fit=crop',
    publishedAt: '2024-12-26',
    readTime: 6,
  },
  {
    id: '9',
    slug: 'vip-transfer-nedir',
    title: 'VIP Transfer Nedir? Mercedes Vito ile Konforlu Yolculuk',
    excerpt: 'Mercedes Vito gibi VIP araçlarla konforlu, prestijli ve zamanında yolculuk. VIP transfer hizmetinin kimler için ideal olduğunu anlatıyoruz.',
    content: `
# VIP Transfer Nedir?

VIP transfer, standart ulaşımın ötesinde; konfor, prestij ve özel hizmet sunan bir yolcu taşıma hizmetidir. Mercedes Vito gibi geniş ve donanımlı VIP araçlarla, yolculuğunuz başlı başına keyifli bir deneyime dönüşür.

## VIP Transfer Kimler İçindir?

- **İş insanları**: Toplantılar arası prestijli ve zamanında ulaşım
- **Aileler**: Geniş iç hacim ve bagaj kapasitesiyle konforlu seyahat
- **Misafir ağırlayanlar**: Önemli misafirlerinizi VIP araçla karşılayın
- **Özel günler**: Davet, kutlama ve organizasyonlar için özel transfer

## Mercedes Vito ile Farkı Hissedin

VIP araçlarımız yolculuğunuzu konforlu kılmak için tasarlanmıştır:

- Geniş ve ferah iç mekan
- Yüksek bagaj kapasitesi
- Profesyonel ve deneyimli şoförler
- Sessiz ve konforlu sürüş

## Süreç Nasıl İşler?

1. **Talep Oluşturma**: Uygulamadan güzergah ve yolcu bilgilerini girin
2. **Özel Fiyatlandırma**: Güzergah ve araç tipine göre teklif alın
3. **Şoför Eşleşmesi**: Profesyonel VIP şoförünüz yönlendirilir
4. **Canlı Takip**: Aracınızı ve şoförünüzü harita üzerinden izleyin
5. **Konforlu Yolculuk**: Belirlediğiniz noktaya prestijli şekilde ulaşın

---

**YolSepetiGO VIP Taşıma** ile her yolculuk ayrıcalıklı!
    `,
    author: authors[1],
    category: categories[7],
    tags: ['vip taşıma', 'vip transfer', 'mercedes vito', 'konforlu yolculuk'],
    coverImage: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&h=400&fit=crop',
    publishedAt: '2024-12-24',
    readTime: 6,
    featured: true,
  },
  {
    id: '10',
    slug: 'havaalani-vip-transfer-avantajlari',
    title: 'Havaalanı Transferinde VIP Hizmetin Avantajları',
    excerpt: 'Uçuş öncesi ve sonrası stresten kurtulun. Havaalanı VIP transferinin sunduğu konfor, dakiklik ve ayrıcalıkları keşfedin.',
    content: `
# Havaalanı Transferinde VIP Hizmetin Avantajları

Havaalanına gidiş veya havaalanından dönüş, seyahatin en yorucu kısmı olabilir. VIP transfer ile bu süreci konforlu, zamanında ve sorunsuz bir deneyime dönüştürürsünüz.

## VIP Havaalanı Transferinin Avantajları

1. **Dakiklik**: Şoförünüz uçuş saatinize göre planlanır, asla geç kalmazsınız.
2. **Konfor**: Mercedes Vito gibi geniş VIP araçlarla rahat bir yolculuk.
3. **Karşılama Hizmeti**: Şoförünüz sizi belirlenen noktada karşılar.
4. **Bagaj Kolaylığı**: Yüksek bagaj kapasitesiyle valizleriniz sorun olmaz.
5. **Stressiz Seyahat**: Park, trafik ve yön derdi olmadan kapıdan kapıya ulaşım.

## Kimler Tercih Etmeli?

- Sık uçan iş insanları
- Kalabalık ve bagajlı seyahat eden aileler
- Önemli misafirlerini karşılayan kurumlar
- Konforu önceleyen tüm yolcular

## YolSepetiGO ile Havaalanı Transferi

YolSepetiGO **VIP Taşıma** ile transferinizi önceden planlayın:

- Uçuş saatinize göre sefer oluşturun
- VIP aracınızı ve şoförünüzü canlı takip edin
- Şeffaf fiyatlandırma ile sürpriz maliyet yok
- 7/24 destek ile her an yanınızdayız

---

**YolSepetiGO VIP Taşıma** ile havaalanı yolculuğunuz konforlu ve zamanında!
    `,
    author: authors[0],
    category: categories[7],
    tags: ['vip taşıma', 'havaalanı transferi', 'vip transfer', 'konforlu yolculuk'],
    coverImage: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&h=400&fit=crop',
    publishedAt: '2024-12-22',
    readTime: 4,
  },
];

// Yardımcı fonksiyonlar
export const getFeaturedPosts = (): BlogPost[] => {
  return blogPosts.filter(post => post.featured);
};

export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

export const getPostsByCategory = (categorySlug: string): BlogPost[] => {
  return blogPosts.filter(post => post.category.slug === categorySlug);
};

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(category => category.slug === slug);
};

// Aynı kategori/etiketten yeterli yazı yoksa en yeni yazılarla tamamlanır,
// böylece "İlgili Yazılar" bölümü hiçbir zaman boş kalmaz
export const getRelatedPosts = (currentPost: BlogPost, limit: number = 3): BlogPost[] => {
  const others = blogPosts.filter(post => post.id !== currentPost.id);
  const related = others.filter(post =>
    post.category.id === currentPost.category.id ||
    post.tags.some(tag => currentPost.tags.includes(tag))
  );
  const fill = others.filter(post => !related.includes(post));
  return [...related, ...fill].slice(0, limit);
};

// "İ/I" gibi Türkçe harflerde doğru eşleşme için tr yereli ile küçültülür
const normalize = (text: string) => text.toLocaleLowerCase('tr-TR');

export const searchPosts = (query: string): BlogPost[] => {
  const lowercaseQuery = normalize(query);
  return blogPosts.filter(post =>
    normalize(post.title).includes(lowercaseQuery) ||
    normalize(post.excerpt).includes(lowercaseQuery) ||
    post.tags.some(tag => normalize(tag).includes(lowercaseQuery))
  );
};
